@if (loading()) {
  <div class="mnm-skeleton" aria-busy="true">
    <div class="mnm-skeleton__line mnm-skeleton__line--kicker"></div>
    <div class="mnm-skeleton__line mnm-skeleton__line--team"></div>
    <div class="mnm-skeleton__line mnm-skeleton__line--team"></div>
    <div class="mnm-skeleton__line mnm-skeleton__line--meta"></div>
  </div>
} @else {
  @if (nextMatch(); as match) {
    <button
      type="button"
      class="mnm-card"
      (click)="onCardClick()"
      [attr.aria-label]="
        'Your next match: ' + match.yourTeamName + ' vs ' + match.opponentName
      "
    >
      <span class="mnm-card__bar" aria-hidden="true"></span>

      <div class="mnm-card__body">
        <header class="mnm-card__head">
          <span class="mnm-kicker">{{ 'UP NEXT' | translate }}</span>
          <span class="mnm-kicker__dot" aria-hidden="true"></span>
          <span class="mnm-kicker mnm-kicker--muted">{{
            match.tournamentName
          }}</span>
        </header>

        <div class="mnm-teams">
          <p class="mnm-team mnm-team--you">{{ match.yourTeamName }}</p>
          <p class="mnm-vs">{{ 'vs' | translate }}</p>
          <p class="mnm-team mnm-team--opponent">{{ match.opponentName }}</p>
        </div>

        <footer class="mnm-meta">
          <span class="mnm-meta__item mnm-meta__item--countdown">
            <i class="pi pi-clock" aria-hidden="true"></i>
            <span>{{ countdown() }}</span>
          </span>
          @if (match.court) {
            <span class="mnm-meta__sep" aria-hidden="true"></span>
            <span class="mnm-meta__item">
              <i class="pi pi-map-marker" aria-hidden="true"></i>
              <span>{{ match.court }}</span>
            </span>
          }
        </footer>
      </div>
    </button>
  }
}
